import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { NgClass } from "@angular/common";

@Component({
    selector: "my-ibox",
    templateUrl: "./ibox.component.html",
    styleUrls: ["./ibox.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class IboxComponent implements OnInit {
    @Input() boxTitle: string;
    @Input() isCollapsible: boolean;
    @Input() defaultCollapsed: boolean;
    @Input() hasTitle = true;

    public collapsed = false;

    public ngOnInit(): void {
        this.collapsed = this.defaultCollapsed;
    }
}
